import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

// eslint-disable-next-line react/prop-types
export const Title = ({title}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const isDesktopOrWider = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !isMobile
  })

  return (
    <TitleBasic as={titleBasicTags.h1} size={isDesktopOrWider ? titleBasicSizes.s : titleBasicSizes.xs} title={title} />
  )
}
